export default __webpack_public_path__ + "static/media/regulatory--radar-enforced--g1.d785a081.png";